import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-disclaimer',
  templateUrl: './landing-disclaimer.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-disclaimer.component.scss']
})
export class LandingDisclaimerComponent {

}
